"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Navbar = _interopRequireDefault(require("react-bootstrap/Navbar"));
var _Nav = _interopRequireDefault(require("react-bootstrap/Nav"));
var _link = require("../link");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FirstTier = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    collapseId,
    navExpanded,
    onNavToggleClick,
    onSearchToggleClick,
    searchExpanded,
    searchNavId,
    trunk
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_Navbar.default.Brand, {
    href: trunk?.navheader?.navSettings?.logoUrl || 'https://www.massmutual.com/',
    rel: "noopener noreferer",
    title: trunk?.navheader?.navSettings?.logoUrl || 'https://www.massmutual.com/'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-r-logo-lg-white",
    role: "img",
    "aria-label": 'MassMutual Logo'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "first-tier-content"
  }, /*#__PURE__*/_react.default.createElement(_Nav.default, {
    className: "audience"
  }, trunk?.navheader?.siteNav?.map(audience => {
    const className = audience.active ? 'active' : '';
    return /*#__PURE__*/_react.default.createElement(_Nav.default.Item, {
      key: audience.label
    }, /*#__PURE__*/_react.default.createElement(_Nav.default.Link, {
      className: className,
      href: (0, _link.absolute)(audience.link)
    }, audience.label));
  })), /*#__PURE__*/_react.default.createElement(_Nav.default, null, trunk?.navheader?.siteUtilityNav?.map(item => {
    if (!item.highlight) {
      return /*#__PURE__*/_react.default.createElement(_Nav.default.Link, {
        href: (0, _link.absolute)(item.link),
        key: item.label,
        title: item.label
      }, item.label);
    }
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-secondary",
      href: (0, _link.absolute)(item.link),
      key: item.label,
      title: item.label
    }, item.label);
  }), trunk?.navheader?.navSettings?.showSearch && /*#__PURE__*/_react.default.createElement(_Navbar.default.Toggle, {
    "aria-controls": searchNavId,
    "aria-expanded": searchExpanded,
    className: "search-button",
    label: "Toggle search",
    onClick: onSearchToggleClick,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Search")), /*#__PURE__*/_react.default.createElement(_Navbar.default.Toggle, {
    "aria-controls": collapseId,
    "aria-expanded": navExpanded,
    onClick: onNavToggleClick
  }))));
});
FirstTier.displayName = 'First Tier';
FirstTier.propTypes = {
  collapseId: _propTypes.default.string,
  navExpanded: _propTypes.default.bool,
  onNavToggleClick: _propTypes.default.func,
  onSearchToggleClick: _propTypes.default.func,
  searchExpanded: _propTypes.default.bool,
  searchNavId: _propTypes.default.string,
  trunk: _propTypes.default.object
};
var _default = exports.default = FirstTier;